<template>
<Animation name="fade">
  <Backdrop v-if="open" @click="handleClick">
    <component
      :is="component"
      :class="rootClass"
      ref="root"
      v-bind="rootProps"
      v-on="$listeners">
      <slot />
    </component>
  </Backdrop>
</Animation>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'
import Backdrop from '../Backdrop'
import Animation from '../Animation'

export default {
  name: 'Dialog',

  mixins: [ defaultRootComponent('div') ],

  components: { Backdrop, Animation },

  props: {
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean
    },

    variant: {
      type: String,
      default: 'center'
    },

    mode: {
      type: String,
      default: 'light'
    },
    /*
     * Vue doesn't include the class & style attributes in its $attrs
     * therefore a custom API is necessary for forwarding purposes
     *
     * coming in Vue 3 though
     */
    rootProps: Object
  },

  provide() {
    return {
      variant: this.variant
    }
  },
  
  mounted() {
    
    window.addEventListener('keydown', this.handleKeydown)
    this.open && window.focus()
    
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    handleClick (e) {
      /* it's possible that another click event lower in the propagation chain
       * has already unmounted this node
       */
      if (!this.$refs.root) { return }

      /*
       * this could also be in the Backdrop checking for
       * event.currentTarget I suppose
       */
      if (!this.$refs.root.contains(e.target)) {
        this.$emit('close')
      }
    },

    handleKeydown (e) {
      if(this.open && e.key === 'Escape' && this.closeOnEsc) {
        this.$emit('close')
      }
    }
  },

  watch: {
    open () {
      window.focus()
    }
  },

  computed: {
    rootClass () {
      return [
        this.$style.root,
        this.$style[this.variant],
        this.$style[this.mode],
        this.rootProps && this.rootProps.class
      ]
    }
  }
}

</script>

<style module>

.root {
  position: absolute;
  z-index: 1000;
  min-width: 600px;
}

.light {
   @apply
    bg-white
    rounded-lg;
}

.dark {
  @apply
    bg-secondary-dark
    rounded-lg;
}

.left {
  top: 0;
  left: 0;
  height: 100vh;
}

.light.left {
  @apply
    border-r
    border-solid
    border-dull;
}

.right {
  top: 0;
  right: 0;
  height: 100vh;
}

.light.right {
  @apply
    border-l
    border-solid
    border-dull;
}

.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.light.center {
  @apply
    border
    border-solid
    border-dull;
}

.fullscreen {
  @apply
    h-full
    w-full;
}

</style>
